import axios from "axios";
import { refreshToken } from "../service/RefreshTokenService";
import { getEnv } from "./EnvHelper";
import { resolveBackendForHost } from "./DomainConfigHelper";
import { clearUserStorage } from "./LocalStorageUtility";


const host = window.location.hostname.toLowerCase();

const axiosInterceptor = axios.create({
    baseURL: getEnv("REACT_APP_HYBRID_MODE") == "true"
        ? window.location.origin + "/"
        : resolveBackendForHost(host).backendUrl ||
              getEnv("REACT_APP_BACKEND_BASE_URL"),
    // headers: {
    //     "Content-Type": "application/json",
    // },
    withCredentials: true,
})

// REMOVED: the X-machineId request header. The backend only logged the value - it was never
// stored or used for authorization or session tracking (device identity comes from
// device_info/ip_address, derived server side from the User-Agent). Removing it takes the
// last client-generated id out of localStorage.
// OLD:
// axiosInterceptor.interceptors.request.use(config => {
//     const machineId = localStorage.getItem("md");
//     if (machineId) {
//         config.headers["X-machineId"] = machineId;
//     }
//     return config;
// }, error => {
//     return Promise.reject(error);
// });

axiosInterceptor.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;
    const isSessionProbe = originalRequest?.url?.includes('jwtServices/load-by-username');
    // 403 is overloaded: an expired token (refresh + retry fixes it) and a
    // deliberate authorization denial from the backend, which errorCode "009"
    // marks. Retrying the latter just burns a refresh and fails again.
    const isAuthorizationDenial = error?.response?.data?.errorCode === "009";
    if (error?.response?.status === 403 && !originalRequest?._retry && !isSessionProbe && !isAuthorizationDenial) {
        originalRequest._retry = true;
        const refreshTokenResponse = await refreshToken();
        if (refreshTokenResponse?.status === 200) {
            return axiosInterceptor(originalRequest);
        }
        // The refresh failed, so the session is genuinely over. Callers handle this by
        // redirecting to the login page (APIs.REDIRECTLOGOUT) from ~339 places, none of
        // which clear storage - so clear it centrally here instead.
        clearUserStorage();
    }
    return Promise.reject(error);
})

export default axiosInterceptor;